import axios from 'axios';
import type { VesselPosition, StaticVesselData, BaseVesselData } from '../types/vessel';

const api = axios.create({ baseURL: '/' });

export async function fetchConfig(): Promise<{ mapboxToken: string }> {
  const { data } = await api.get('/config');
  return data;
}

export async function fetchPositions(): Promise<Record<string, VesselPosition>> {
  const { data } = await api.get('/positions');
  console.log('Positions response:', Object.keys(data).length, 'vessels');
  return data || {};
}

export async function fetchStaticData(): Promise<Record<string, StaticVesselData>> {
  const { data } = await api.get('/data/vesselStaticData.json');
  return data;
}

export async function fetchBaseData(): Promise<BaseVesselData[]> {
  const { data } = await api.get('/data/lngVessels.json');
  console.log('BaseData response:', Array.isArray(data) ? data.length : 0, 'vessels');
  return data || [];
}

export async function fetchUnlocodeRegister(): Promise<Array<{ Country: string; Location: string; Name: string }>> {
  const { data } = await api.get('/data/unlocodeRegister.json');
  return data;
}

export async function fetchCountries(): Promise<Array<{ CountryCode: string; CountryName: string }>> {
  const { data } = await api.get('/data/allCountries.json');
  return data;
}
